export { Thumbs } from "./Thumbs";
